import angular from 'angular'

export default angular.module('inicio', [])



// WEBPACK FOOTER //
// ./src/inicio/module.js